import { camelCase } from 'lodash';

export class MapData {
  mapId: number = null;
  mapCustomerId: number = null;
  mapJson: {
    type: string,
    features: {
      geometry: {
        coordinates: number[][],
        type: string,
      },
      properties: {
        GeoFenceName?: string,
      },
      type: string,
    }[],
  } = null;

  constructor(obj?: any) {
    for (const field in obj) {
      const camelCasedField = camelCase(field);
      if (typeof this[camelCasedField] !== 'undefined') {
        this[camelCasedField] = obj && JSON.parse(obj[field]);
      }
    }
  }
}
